import { professionalServiceIndexEntries } from "../services/professionalServices";

const legacyServicesIndex = [
  {
    title: "Plumber",
    icon: "🚰",
    path: "/plumber",
    category: "Repairs & Installation",
    tags: ["tap", "leakage", "drainage", "bathroom", "sink", "pipe"],
  },
  {
    title: "Electrician",
    icon: "⚡",
    path: "/electrician",
    category: "Repairs & Installation",
    tags: ["switch", "socket", "fan", "light", "wiring", "mcb"],
  },
  {
    title: "Carpenter",
    icon: "🪚",
    path: "/carpenter",
    category: "Repairs & Installation",
    tags: ["door", "lock", "hinge", "shelf", "furniture", "drawer"],
  },
  {
    title: "AC Repair",
    icon: "❄️",
    path: "/ac-repair",
    category: "Appliance Services",
    tags: ["ac", "cooling", "gas", "installation", "service", "uninstallation"],
  },
  {
    title: "Washing Machine Repair",
    icon: "🫧",
    path: "/washing-machine-repair",
    category: "Appliance Services",
    tags: ["washing machine", "drainage", "spin", "installation", "repair"],
  },
  {
    title: "Refrigerator Repair",
    icon: "🧊",
    path: "/refrigerator-repair",
    category: "Appliance Services",
    tags: ["fridge", "cooling", "door", "leakage", "repair"],
  },
  {
    title: "Microwave Repair",
    icon: "🍲",
    path: "/microwave-repair",
    category: "Appliance Services",
    tags: ["microwave", "heating", "power", "turntable"],
  },
  {
    title: "Water Purifier Repair",
    icon: "🚰",
    path: "/water-purifier-repair",
    category: "Appliance Services",
    tags: ["ro", "purifier", "filter", "leakage", "servicing"],
  },
  {
    title: "Geyser Repair",
    icon: "♨️",
    path: "/geyser-repair",
    category: "Appliance Services",
    tags: ["geyser", "heating", "water", "installation", "repair"],
  },
  {
    title: "Chimney Service",
    icon: "🌫️",
    path: "/chimney-service",
    category: "Appliance Services",
    tags: ["chimney", "kitchen", "cleaning", "suction"],
  },
  {
    title: "TV Repair",
    icon: "📺",
    path: "/tv-repair",
    category: "Appliance Services",
    tags: ["tv", "display", "sound", "wall mount"],
  },
  {
    title: "Laptop Basic Support",
    icon: "💻",
    path: "/laptop-basic-support",
    category: "Appliance Services",
    tags: ["laptop", "software", "diagnosis", "os", "support"],
  },
  {
    title: "Labour",
    icon: "👷",
    path: "/labour",
    category: "Construction & Labour",
    tags: ["site", "loading", "unloading", "movement", "construction"],
  },
  {
    title: "Helper",
    icon: "🤝",
    path: "/helper",
    category: "Construction & Labour",
    tags: ["helper", "support", "movement", "assistance"],
  },
  {
    title: "Mason / Mistri",
    icon: "🧱",
    path: "/mason-mistri",
    category: "Construction & Labour",
    tags: ["mason", "brick", "plaster", "civil", "wall"],
  },
  {
    title: "Steel Rod & Wire Work",
    icon: "🧵",
    path: "/steel-rod-wire-work",
    category: "Construction & Labour",
    tags: ["rebar", "rod", "wire", "binding", "fabrication", "industrial"],
  },
  {
    title: "Painter",
    icon: "🎨",
    path: "/painter",
    category: "Construction & Labour",
    tags: ["paint", "wall", "putty", "touch up"],
  },
  {
    title: "Tile Worker",
    icon: "🟫",
    path: "/tile-worker",
    category: "Construction & Labour",
    tags: ["tile", "grout", "replacement", "floor"],
  },
  {
    title: "Welder",
    icon: "🔥",
    path: "/welder",
    category: "Construction & Labour",
    tags: ["welding", "grill", "gate", "metal"],
  },
  {
    title: "POP / False Ceiling Worker",
    icon: "🏠",
    path: "/pop-false-ceiling-worker",
    category: "Construction & Labour",
    tags: ["ceiling", "pop", "false ceiling", "patch"],
  },
  {
    title: "Rooftop Waterproofing Worker",
    icon: "🛡️",
    path: "/rooftop-waterproofing-worker",
    category: "Construction & Labour",
    tags: ["roof", "waterproofing", "terrace", "leakage"],
  },
  {
    title: "Fabricator",
    icon: "🛠️",
    path: "/fabricator",
    category: "Construction & Labour",
    tags: ["fabrication", "metal", "frame", "grill"],
  },
  {
    title: "Aluminium Worker",
    icon: "🔩",
    path: "/aluminium-worker",
    category: "Construction & Labour",
    tags: ["aluminium", "partition", "frame", "channel"],
  },
  {
    title: "Glass Fitter",
    icon: "🪟",
    path: "/glass-fitter",
    category: "Construction & Labour",
    tags: ["glass", "panel", "fitting", "alignment"],
  },
  {
    title: "Modular Kitchen Installer",
    icon: "🍽️",
    path: "/modular-kitchen-installer",
    category: "Construction & Labour",
    tags: ["kitchen", "cabinet", "modular", "accessories"],
  },
  {
    title: "Door / Window Fitter",
    icon: "🚪",
    path: "/door-window-fitter",
    category: "Repairs & Installation",
    tags: ["door", "window", "fitting", "lock", "hinge"],
  },
  {
    title: "CCTV Technician",
    icon: "📹",
    path: "/cctv-technician",
    category: "Repairs & Installation",
    tags: ["cctv", "camera", "dvr", "security"],
  },
  {
    title: "Solar Technician",
    icon: "☀️",
    path: "/solar-technician",
    category: "Repairs & Installation",
    tags: ["solar", "panel", "inverter", "rooftop"],
  },
  {
    title: "Bore / Pump Technician",
    icon: "💧",
    path: "/bore-pump-technician",
    category: "Repairs & Installation",
    tags: ["pump", "bore", "motor", "water"],
  },
  {
    title: "Gardening",
    icon: "🌿",
    path: "/gardening",
    category: "Home Help & Lifestyle",
    tags: ["plants", "balcony", "trimming", "garden"],
  },
  {
    title: "House Maid",
    icon: "🧹",
    path: "/house-maid",
    category: "Home Help & Lifestyle",
    tags: ["maid", "dusting", "mopping", "utensils", "cleaning"],
  },
  {
    title: "Cook / Chef",
    icon: "👨‍🍳",
    path: "/cook-chef",
    category: "Home Help & Lifestyle",
    tags: ["cook", "chef", "meal", "kitchen", "food"],
  },
  {
    title: "Nanny / Care-taker",
    icon: "🧸",
    path: "/nanny-caretaker",
    category: "Home Help & Lifestyle",
    tags: ["nanny", "babysitting", "elder care", "caretaker"],
  },
  {
    title: "Home Tutor",
    icon: "📚",
    path: "/home-tutor",
    category: "Home Help & Lifestyle",
    tags: ["tutor", "teaching", "home tuition", "study"],
  },
  {
    title: "Yoga Instructor",
    icon: "🧘",
    path: "/yoga-instructor",
    category: "Home Help & Lifestyle",
    tags: ["yoga", "wellness", "fitness", "breathing"],
  },
  {
    title: "Dog Walker / Sitter",
    icon: "🐶",
    path: "/dog-care",
    category: "Home Help & Lifestyle",
    tags: ["dog", "pet", "walk", "sitter"],
  },
  {
    title: "Car Cleaning",
    icon: "🚗",
    path: "/car-cleaning",
    category: "Home Help & Lifestyle",
    tags: ["car", "cleaning", "interior", "exterior"],
  },
  {
    title: "Insta Help",
    icon: "⚡",
    path: "/insta-help",
    category: "Quick Help",
    tags: ["quick", "help", "small tasks", "urgent"],
  },
  {
    title: "Materials",
    icon: "📦",
    path: "/materials",
    category: "Marketplace",
    tags: ["cement", "steel", "tiles", "inventory", "suppliers"],
  },
  {
    title: "Build Your House",
    icon: "🏠",
    path: "/build-your-house",
    category: "Marketplace",
    tags: ["house", "plan", "budget", "construction"],
  },
];

export const allServiceCategories = [
  "Repairs & Installation",
  "Appliance Services",
  "Construction & Labour",
  "Home Help & Lifestyle",
  "Quick Help",
  "Marketplace",
  "Professional & Project Services",
];

export const allServicesIndex = [
  ...legacyServicesIndex,
  ...professionalServiceIndexEntries,
];
